import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraIconButton } from '../ensigns/icon-button';
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraProgress } from '../ensigns/progress';
import { SpecraText } from '../ensigns/typography';
/** Upload/attachment row with progress and removal affordance. */ export function SpecraAttachmentRow({ className, icon, meta, name, onRemove, progress, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex items-center gap-3 rounded-md border border-border p-2.5', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraIconTile, {
                children: icon ?? '↥'
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate",
                        size: "caption",
                        children: name
                    }),
                    progress !== undefined ? /*#__PURE__*/ _jsx(SpecraProgress, {
                        "aria-label": `${name} upload progress`,
                        className: "mt-1.5",
                        size: "thin",
                        value: progress
                    }) : meta ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block",
                        size: "micro",
                        tone: "muted",
                        children: meta
                    }) : null
                ]
            }),
            onRemove ? /*#__PURE__*/ _jsx(SpecraIconButton, {
                label: `Remove ${name}`,
                onClick: onRemove,
                size: "sm",
                variant: "ghost",
                children: "×"
            }) : null
        ]
    });
}
